import { render } from "./ImpressumComponent.vue?vue&type=template&id=b022c5aa&ts=true"
import script from "./ImpressumComponent.vue?vue&type=script&lang=ts"
export * from "./ImpressumComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__